<template src="../template/reg_1.html"></template>

<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { startToWatchGps, sendGeoLocation } from '../utils/geolocationUtil'

export default {
  name: 'Reg-1',
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE']),
    ...mapGetters(['getProjectId', 'getQRCode'])
  },
  created: function () {
    // console.log('Vue.prototype.$deviceCode = ' + this.prototype.$deviceCode)
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      // console.info(`======: ${window.localStorage.getItem('gpsTimeID')}`)
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    startToWatchGps()
    sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-1')
    const timeoutID = window.setInterval(
      () => {
        sendGeoLocation(this.getProjectId, this.getQRCode, 'Reg-1')
      }, 15000
    )
    // console.info(`timeoutID: ${timeoutID}`)
    window.localStorage.setItem('gpsTimeID', timeoutID)

    if (_.isEmpty(this.getProjectId) || _.isEmpty(this.getQRCode)) {
      this.$swal({
        title: '找不到專案代碼與 QR Code',
        text: '系統將自動導至官網',
        type: 'error'
      }).then(function (result) {
        if (result.value) {
          window.location.href = window.localStorage.getItem('projectOfficialSite')
        }
      })
    }
  },
  methods: {
  }
}
</script>
